import { EMPTY_ARRAY } from 'commons-ui';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import useService from '../utils/useService';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;
	const { segmentLabelList, mapValueList } = useService();
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.finance,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateCTDOffers,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Clone',
				id: 'clone',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.finance,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createCTD,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Show Conversion Details',
				id: 'offers',
				isEnabled: () => {
					return true;
				}
			},
			{
				name: 'Remove from App',
				id: 'remove',
				isEnabled: () => {
					return true;
				}
			}
		],

		bulkActions: EMPTY_ARRAY,

		addAction: {
			segmentList: segmentLabelList,
			mapList: mapValueList,
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.finance,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createOffer,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
